import React, { useContext, useEffect, useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from '../helpers/axiosConfig';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../helpers/AuthContext';

function CreatBooks() {
  const [listCategorie, setListCategorie] = useState([]);

  const navigate = useNavigate();
  const initialValues = {
    titre: '',
    page: 0,
  };

  useEffect(() => {
    if (!localStorage.getItem('accessToken')) {
      navigate('/login');
    }
    axios
      .get('/categorie', {
        headers: { accessToken: localStorage.getItem('accessToken') },
      })
      .then((response) => {
        setListCategorie(response.data.listCategorie);
      });
  }, []);

  const validation = Yup.object().shape({
    titre: Yup.string().required('Veuillez remplir le Titre'),
  });

  const Enregister = (data) => {
    axios
      .post('/books', data, {
        headers: { accessToken: localStorage.getItem('accessToken') },
      })
      .then((response) => {
        console.log(response);
      });
    navigate('/books');
  };

  return (
    <React.Fragment>
      <h1>Creation Post</h1>
      <Formik initialValues={initialValues} onSubmit={Enregister} validationSchema={validation}>
        <Form>
          <div className="d-flex">
            <div className="col">
              <label htmlFor="titre">Titre : </label>
              <ErrorMessage className="text-danger" name="titre" component="span" />
              <Field className="form-control" id="titre" name="titre" placeholder="Titre du livre" />
            </div>
            <div className="col">
              <label htmlFor="page">Nombre de page : </label>
              <ErrorMessage className="text-danger" name="page" component="span" />
              <Field className="form-control" id="page" name="page" placeholder="Nombre de page" />
            </div>
            <div className="col">
              <label htmlFor="categorie">Categorie : </label>
              <ErrorMessage className="text-danger" name="categorie" component="span" />
              <Field as="select" className="form-control" id="categorie" name="categorie">
                {listCategorie.map((categorie, key) => {
                  return (
                    <option key={key} value={categorie.id}>
                      {categorie.name}
                    </option>
                  );
                })}
              </Field>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <button className="mt-3 btn btn-primary" type="submit">
                Enregistrer
              </button>
            </div>
          </div>
        </Form>
      </Formik>
    </React.Fragment>
  );
}

export default CreatBooks;
